<div class="wrapper">
    <div class="page-wrapper pt-4">
        <div class="page-content pt-0 pe-2 ps-2">
            <div class="container-fluid">
                <div class="default_class">
                    <div class="content-wrapper p-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="card rounded shadow-lg">
                                        <div class="card-header headerbg" style="border-bottom: 3px solid #d8eff8">
                                            <h5 class="mb-0">User Guide Configuration</h5>
                                        </div>

                                        <div class="card-body">
                                            <div class="text-right mb-1">
                                                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                                data-bs-target="#coursesModal" (click)="isEdit=false;Clear()">
                                                    Add
                                                </button>
                                            </div>

                                            <div *ngIf="table.length">
                                                <table id="patreggraph" datatable
                                                    class="table-striped table-bordered mt-2 pt-2 table-sm small"
                                                    style="width: 100%">
                                                    <thead class="top">
                                                        <tr>
                                                            <!-- <th>Academic Year </th> -->
                                                            <th>Menu</th>
                                                            <th>SubMenu</th>
                                                            <th>Screen</th>
                                                            <th>Language</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let item of table">
                                                            <td>{{ item.MENU_NAME }}</td>
                                                            <td>{{ item.SUB_MENU_NAME }}</td>
                                                            <td>{{ item.SCREEN_NAME }}</td>
                                                            <td>English</td>
                                                            <!-- <td>
                                                                <button class="btn btn-save" data-bs-toggle="modal"
                                                                    data-bs-target="#coursesModal"
                                                                    (click)="getViewCourses(item)">
                                                                    view
                                                                </button>
                                                            </td> -->

                                                            <td style="cursor: pointer">
                                                                <button class="btn btn-save me-2" data-bs-toggle="modal" data-bs-target="#coursesModal"
                                                                (click)="isView=true;GetById(item, 'view')">
                                                                    view
                                                                </button>
                                                                <button data-bs-toggle="modal" data-bs-target="#coursesModal"
                                                                    (click)="GetById(item, 'edit')" class="btn btn-save">Edit
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="text-center" *ngIf="!table.length">
                                                No Records to display
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" tabindex="-1" id="coursesModal">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">User Guide Configuration</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="md_close" aria-label="Close" (click)="Clear()"></button>
            </div>
            <div class="modal-body" *ngIf="!isView">
                <div class="col-md-12">
                    <div class="form-group row pt-4">
                        <!-- <h5>User Guide Configuration</h5> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-2"></div>
                    <div class="col-md-6">
                        <div class="form-group row pt-4">
                          <label class="col-md-4 control-label line_2 rem_1">
                            Menu <span class="text-danger">*</span></label>
                          <div class="col-md-8 inputGroupContainer">
                            <div class="input-group">
                              <strong>:</strong> &nbsp;
                              <select class="form-select" [(ngModel)]="menuId" (change)="GetSubMenuList($any($event.target).value)" [disabled]="isEdit">
                                <option value="" disabled selected>Select</option>
                                <option *ngFor="let m of menuList" [value]="m.TaskId">
                                  {{ m.TaskName }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-2"></div>
                    <div class="col-md-6">
                        <div class="form-group row pt-4">
                          <label class="col-md-4 control-label line_2 rem_1">
                            Sub Menu / Screen Name</label>
                          <div class="col-md-8 inputGroupContainer">
                            <div class="input-group">
                              <strong>:</strong> &nbsp;
                              <select class="form-select" [(ngModel)]="subMenuId" (change)="GetScreenList($any($event.target).value)" [disabled]="isEdit">
                                <option value="" disabled selected>Select</option>
                                <option *ngFor="let m of subMenuList" [value]="m.TaskId">
                                    {{ m.TaskName }}
                                  </option>
                              </select>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="screensList.length > 0">
                    <div class="col-xl-2"></div>
                    <div class="col-md-6">
                        <div class="form-group row pt-4">
                          <label class="col-md-4 control-label line_2 rem_1">
                            Screen Name </label>
                          <div class="col-md-8 inputGroupContainer">
                            <div class="input-group">
                              <strong>:</strong> &nbsp;
                              <select class="form-select" [(ngModel)]="screenId" [disabled]="isEdit">
                                <option value="" disabled selected>Select</option>
                                <option *ngFor="let m of screensList" [value]="m.TaskId">
                                    {{ m.TaskName }}
                                  </option>
                              </select>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-2"></div>
                    <div class="col-md-6">
                        <div class="form-group row pt-4">
                          <label class="col-md-4 control-label line_2 rem_1">
                            Language </label>
                          <div class="col-md-8 inputGroupContainer">
                            <div class="input-group">
                              <strong>:</strong> &nbsp;
                              <select class="form-select" [(ngModel)]="languageId">
                                <option value="" disabled selected>Select</option>
                                <option *ngFor="let l of languageList" [value]="l.id">
                                  {{ l.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group row pt-4">
                          <!-- <label class="col-md-4 control-label line_2 rem_1">
                            Menu <span class="text-danger">*</span></label> -->
                          <div class="col-md-12 inputGroupContainer">
                            <div class="input-group editor">
                                <angular-editor
                                  class="angular_editor"
                                  [(ngModel)]="htmlContent"
                                  (input)="showHtml()"
                                  [ngModelOptions]="{ standalone: true }"
                                  [config]="config"
                                  [placeholder]="'Enter text here...'">
                                </angular-editor>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row modal-body" *ngIf="isView">
                <div class="col-xl-12">
                    <div class="card rounded shadow-lg">
                        <div class="card-header headerbg" style="border-bottom: 3px solid #d8eff8">
                            <h5 class="mb-0" *ngIf="editData?.SUB_MENU_NAME == null || editData?.SUB_MENU_NAME == ''">{{editData?.MENU_NAME}}  User Manual</h5>
                            <h5 class="mb-0" *ngIf="(editData?.SUB_MENU_NAME != null && editData?.SUB_MENU_NAME != '') && 
                            (editData?.SCREEN_NAME == null || editData?.SCREEN_NAME == '')">{{editData?.MENU_NAME}} >> {{editData?.SUB_MENU_NAME}}  User Manual</h5>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-12">
                                <div id="htmldiv" class="unselectable" style="font-size: 16px;color:#4c5a73" [innerHTML]="htmlContent">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="Clear()">
                    Close
                </button>
                <button type="button" class="btn btn-primary" (click)="save()" *ngIf="!isView">{{isEdit ? 'Update' : 'Save'}}</button>
            </div>
        </div>
    </div>
</div>